import { render, staticRenderFns } from "./CountryTab.vue?vue&type=template&id=d23e31ce&scoped=true&"
import script from "./CountryTab.vue?vue&type=script&lang=js&"
export * from "./CountryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23e31ce",
  null
  
)

export default component.exports